import React from "react";
import { useEffect, useState } from "react";
import { firestore } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import "../scss/Scss/Home.scss";
import { Link } from "react-router-dom";

function ContactPage() {
  const [dataCIWEB, setDataCIWEB] = useState(null);
  const [dataCISafetyEdit, setDataCISafetyEdit] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const docRefCIWEB = doc(firestore, "CI WEB", "Home");
    const docRefCISafetyEdit = doc(firestore, "CI WEB - SAFETY EDIT", "Home");

    const fetchDataCIWEB = async () => {
      try {
        const docSnapshot = await getDoc(docRefCIWEB);
        if (docSnapshot.exists()) {
          setDataCIWEB(docSnapshot.data());
        } else {
          console.log("No such document for CI WEB!");
        }
      } catch (error) {
        console.error("Error fetching document for CI WEB:", error);
      }
    };

    const fetchDataCISafetyEdit = async () => {
      try {
        const docSnapshot = await getDoc(docRefCISafetyEdit);
        if (docSnapshot.exists()) {
          setDataCISafetyEdit(docSnapshot.data());
        } else {
          console.log("No such document for CI WEB - SAFETY EDIT!");
        }
      } catch (error) {
        console.error(
          "Error fetching document for CI WEB - SAFETY EDIT:",
          error
        );
      }
    };

    fetchDataCIWEB();
    fetchDataCISafetyEdit();

    setIsMobile(window.innerWidth <= 1366);
    window.addEventListener("resize", () => {
      setIsMobile(window.innerWidth <= 1366);
    });

    return () => {
      window.removeEventListener("resize", () => {
        setIsMobile(window.innerWidth <= 1366);
      });
    };
  }, []);

  return (
    <>
      {dataCIWEB && dataCISafetyEdit && (
        <div className="Home-Contact">
          {!isMobile ? (
            <div className="SubheadingContact">
              <div className="text-SubheadingContact">
                <div className="text1Contact">
                  {dataCISafetyEdit.text1Contact}
                </div>
                <div className="text2Contact">
                  {dataCISafetyEdit.text2Contact}
                </div>
                <div className="text3Contact">
                  {dataCISafetyEdit.text3Contact}
                </div>
                <div className="text4Contact">
                  {dataCISafetyEdit.text4Contact}
                  <span>!</span>
                </div>
                <Link to="/contact" className="BtnContact">
                  CONTACT US
                </Link>
              </div>
            </div>
          ) : (
            <div className="text-SubheadingContactMB">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  width: "100%",
                  height: "auto",
                }}
              >
                <div className="AlltextContact1MB">
                  <div className="text1ContactMB">
                    {dataCISafetyEdit.text1Contact}
                  </div>
                  <div className="text2ContactMB">
                    {dataCISafetyEdit.text2Contact}
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    fontSize: "clamp(1rem, 6vw, 5rem)",
                  }}
                >
                  <div className="text3ContactMB">
                    {dataCISafetyEdit.text3Contact}
                  </div>
                  <div className="text4ContactMB">
                    {dataCISafetyEdit.text4Contact}
                    <span>!</span>
                  </div>
                </div>
              </div>
              <Link to="/contact" className="BtnContactMB">
                CONTACT US
              </Link>
            </div>
          )}

          {!isMobile ? (
            <div
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              <video
                loop
                muted
                autoPlay
                playsInline
                className="BgVideoContact"
                style={{ pointerEvents: "auto" }}
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src={dataCISafetyEdit.CIWEBHOMECONTACTNOTEXT}
                  type="video/mp4"
                />
              </video>
            </div>
          ) : (
            <div style={{ width: "100%", height: "auto" }}>
              <img
                src={dataCISafetyEdit.CIWEBHOMECONTACTNOTEXTMOBILE}
                alt="Img"
                loading="lazy"
                style={{ pointerEvents: "auto", marginTop: "15rem" }}
                width="100%"
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default ContactPage;
